import * as TYPES from './types'

export default {
  setLanguage ({ commit }, obj) {
    commit(TYPES.MAIN_SET_LANGUAGE, obj)
  }
}
